// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"80":"ca0c108b","756":"ca0c108b"}[chunkId] + ".chunk.css";
};